

/* Live Chat */
    jQuery(document).ready(function(){
        /* alert(''); */
    
        jQuery('.chat-close').on('click', function() {
            jQuery('.chat-tab-wrapper').fadeOut(500, function() {
                jQuery(this).hide();
            });
        });
      
    });

